import { z } from 'zod';

import { Status } from '@shaojiang/types/common';

export const FeatureSchema = z.object({
  name: z.string(),
  description: z.string(),
  url: z.string(),
});

export const WorkExpSchema = z.object({
  hidden: z.boolean().optional(),
  company: z.string(),
  companyUrl: z.string(),
  companyLogo: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  title: z.string(),
  responsibilities: z.array(z.string()),
  projects: z.array(z.string()),
});

export const ProjectSchema = z.object({
  hidden: z.boolean().optional(),
  slug: z.string(),
  company: z.string(),
  companyLogo: z.string(),
  companyUrl: z.string(),
  description: z.string(),
  endDate: z.string(),
  facebook: z.string().optional(),
  features: z.array(FeatureSchema),
  github: z.string().optional(),
  image: z.string(),
  video: z.string().optional(),
  name: z.string(),
  startDate: z.string().optional(),
  tags: z.array(z.string()),
  title: z.string(),
  url: z.string(),
  authRequired: z.boolean(),
  status: z.enum(Status),
  responsibilities: z.array(z.string()),
});

export type Feature = z.infer<typeof FeatureSchema>;
export type WorkExp = z.infer<typeof WorkExpSchema>;
export type Project = z.infer<typeof ProjectSchema>;
